export interface FeatureItem {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export interface MovieItem {
  id: string;
  title: string;
  poster: string;
  category: string;
  tags: string[];
  desc: string;
  rating: string;
  year: string;
}

export interface ScenarioItem {
  id: string;
  image: string;
  title: string;
  desc: string;
  icon: string;
}

export interface StepItem {
  id: string;
  index: string;
  title: string;
  desc: string;
}

export interface QualityItem {
  id: string;
  label: string;
  resolution: string;
  scene: string;
  data: string;
}

export interface ReviewItem {
  id: string;
  name: string;
  role: string;
  initials: string;
  content: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const navLinks = [
  { id: "features", label: "核心特色" },
  { id: "catalog", label: "热门片库" },
  { id: "scenes", label: "使用场景" },
  { id: "guide", label: "观看指南" },
  { id: "quality", label: "画质与缓存" },
  { id: "faq", label: "常见问题" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20with%20rows%20of%20empty%20seats%20facing%20a%20glowing%20warm%20golden%20screen%2C%20volumetric%20light%20beams%20through%20haze%2C%20deep%20amber%20and%20charcoal%20tones%2C%20atmospheric%20premium%20mood%2C%20no%20text&width=1920&height=1080&seq=hero-cinema-01&orientation=landscape";

export const qualityImage =
  "https://readdy.ai/api/search-image?query=A%20large%20high%20definition%20television%20screen%20showing%20a%20vivid%20colorful%20abstract%20film%20scene%20in%20a%20dark%20room%2C%20warm%20ambient%20glow%2C%20premium%20home%20cinema%20feel%2C%20no%20text&width=800&height=600&seq=quality-screen-01&orientation=landscape";

export const adFreeImage =
  "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20person%20relaxing%20on%20a%20sofa%20holding%20a%20remote%20control%20in%20a%20dim%20home%20theater%2C%20warm%20golden%20glow%20from%20the%20screen%2C%20calm%20undisturbed%20mood%2C%20no%20text&width=900&height=700&seq=adfree-remote-01&orientation=landscape";

export const features: FeatureItem[] = [
  {
    id: "online",
    icon: "ri-play-circle-line",
    title: "在线观看",
    desc: "无需下载客户端，打开网页即可直接播放。资源聚合在同一入口，减少在多个站点之间来回切换的麻烦。",
  },
  {
    id: "free",
    icon: "ri-gift-line",
    title: "免费观看",
    desc: "基础片库提供免费观看入口，打开即可浏览热播片单，适合想先看看再决定看什么的用户。",
  },
  {
    id: "hd",
    icon: "ri-hd-line",
    title: "高清播放",
    desc: "同一部作品通常提供多档清晰度，弱网环境自动降档保证流畅，网络良好时可以手动切到高清档位。",
  },
  {
    id: "download",
    icon: "ri-download-2-line",
    title: "下载",
    desc: "支持把想看的剧集下载到本地，出门在外没有网络也能接着看，适合长途出行前提前准备。",
  },
  {
    id: "cache",
    icon: "ri-hard-drive-2-line",
    title: "缓存",
    desc: "边看边缓存，进度会自动保存。断网或切后台后重新打开，可以从上次的位置继续播放。",
  },
  {
    id: "no-ad",
    icon: "ri-shield-check-line",
    title: "无广告观看",
    desc: "播放过程尽量保持干净，减少贴片与弹窗干扰，让整段剧情可以连贯看完，不被打断节奏。",
  },
];

export const movieCategories = ["全部", "电影", "剧集", "动漫", "综艺", "纪录片"];

export const movies: MovieItem[] = [
  {
    id: "m1",
    title: "星际回声",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20artwork%2C%20lone%20astronaut%20silhouette%20against%20a%20glowing%20nebula%20and%20distant%20planet%2C%20deep%20amber%20and%20teal%20tones%2C%20dramatic%20rim%20light%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-scifi-01&orientation=portrait",
    category: "电影",
    tags: ["科幻", "冒险"],
    desc: "一支深空救援队在返航途中收到来自废弃空间站的信号，真相在回声中逐渐浮现。",
    rating: "8.9",
    year: "2025",
  },
  {
    id: "m2",
    title: "剑气长歌",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20wuxia%20period%20drama%20poster%20artwork%2C%20swordswoman%20in%20flowing%20robe%20standing%20on%20a%20misty%20mountain%20cliff%2C%20warm%20golden%20sunset%20haze%2C%20painterly%20style%2C%20no%20text&width=600&height=900&seq=poster-wuxia-02&orientation=portrait",
    category: "剧集",
    tags: ["武侠", "古装"],
    desc: "江湖旧案重启，一把断剑牵出三代人的恩怨，长歌当哭也当剑。",
    rating: "9.1",
    year: "2024",
  },
  {
    id: "m3",
    title: "我们的雨天",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20romance%20film%20poster%20artwork%2C%20a%20couple%20under%20warm%20street%20lights%20on%20a%20rainy%20city%20night%2C%20soft%20bokeh%2C%20warm%20amber%20tones%2C%20no%20text&width=600&height=900&seq=poster-romance-03&orientation=portrait",
    category: "电影",
    tags: ["爱情", "都市"],
    desc: "两个在雨夜错过的人，用一整年的时间学会好好说再见。",
    rating: "8.4",
    year: "2025",
  },
  {
    id: "m4",
    title: "雾港迷案",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%20artwork%2C%20detective%20silhouette%20in%20a%20foggy%20alley%20with%20a%20single%20street%20lamp%2C%20moody%20high%20contrast%2C%20muted%20teal%20and%20amber%20tones%2C%20no%20text&width=600&height=900&seq=poster-thriller-04&orientation=portrait",
    category: "剧集",
    tags: ["悬疑", "犯罪"],
    desc: "港口连续失踪案背后，是一张被雾气遮住多年的旧照片。",
    rating: "9.3",
    year: "2025",
  },
  {
    id: "m5",
    title: "森林之约",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20fantasy%20film%20poster%20artwork%2C%20a%20young%20hero%20and%20a%20glowing%20magical%20creature%20in%20an%20enchanted%20forest%2C%20vibrant%20green%20and%20gold%20light%2C%20painterly%20style%2C%20no%20text&width=600&height=900&seq=poster-anime-05&orientation=portrait",
    category: "动漫",
    tags: ["奇幻", "治愈"],
    desc: "少女与守护灵立下约定，要在森林消失之前找回最后一颗种子。",
    rating: "9.0",
    year: "2024",
  },
  {
    id: "m6",
    title: "破晓前线",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20war%20epic%20poster%20artwork%2C%20soldiers%20marching%20at%20dawn%20through%20smoke%2C%20muted%20earth%20tones%20with%20a%20pale%20dramatic%20sky%2C%20no%20text&width=600&height=900&seq=poster-war-06&orientation=portrait",
    category: "电影",
    tags: ["历史", "战争"],
    desc: "一场发生在黎明前的坚守，把普通人的选择写成了史诗。",
    rating: "8.7",
    year: "2023",
  },
  {
    id: "m7",
    title: "故乡的夏天",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20family%20drama%20poster%20artwork%2C%20a%20family%20silhouette%20at%20a%20countryside%20sunset%2C%20golden%20hour%20glow%2C%20nostalgic%20tone%2C%20no%20text&width=600&height=900&seq=poster-family-07&orientation=portrait",
    category: "电影",
    tags: ["家庭", "温情"],
    desc: "老屋要拆了，一家人时隔十年回到故乡，重新学着一桌吃饭。",
    rating: "8.6",
    year: "2024",
  },
  {
    id: "m8",
    title: "巅峰之夜",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20stage%20poster%20artwork%2C%20dramatic%20stage%20lights%20and%20confetti%20in%20a%20dark%20theater%2C%20warm%20gold%20and%20red%20glow%2C%20no%20text&width=600&height=900&seq=poster-variety-08&orientation=portrait",
    category: "综艺",
    tags: ["音乐", "竞演"],
    desc: "十二位音乐人同台竞演，每一期都用一首歌讲述一个真实的夜晚。",
    rating: "8.8",
    year: "2025",
  },
  {
    id: "m9",
    title: "雪线之上",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20poster%20artwork%2C%20a%20snow%20leopard%20standing%20on%20a%20rocky%20ridge%20at%20golden%20hour%2C%20majestic%20natural%20tones%2C%20no%20text&width=600&height=900&seq=poster-doc-nature-09&orientation=portrait",
    category: "纪录片",
    tags: ["自然", "动物"],
    desc: "跟随镜头走上高原雪线，记录那些极少被人看见的生命瞬间。",
    rating: "9.2",
    year: "2024",
  },
  {
    id: "m10",
    title: "一碗烟火",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20food%20documentary%20poster%20artwork%2C%20steaming%20hand-pulled%20noodles%20in%20a%20rustic%20bowl%2C%20warm%20ambient%20light%2C%20rich%20textures%2C%20no%20text&width=600&height=900&seq=poster-doc-food-10&orientation=portrait",
    category: "纪录片",
    tags: ["美食", "人文"],
    desc: "从街边小摊到深夜食堂，一碗面的背后是一座城市的生活节奏。",
    rating: "9.0",
    year: "2025",
  },
  {
    id: "m11",
    title: "银河边界",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20space%20adventure%20poster%20artwork%2C%20a%20sleek%20starship%20traveling%20through%20golden%20cosmic%20dust%20toward%20a%20warm%20amber%20nebula%2C%20no%20text&width=600&height=900&seq=poster-scifi-11&orientation=portrait",
    category: "电影",
    tags: ["科幻", "太空"],
    desc: "人类第一艘远航舰抵达边界，却发现那里早就有人在等待。",
    rating: "8.5",
    year: "2025",
  },
  {
    id: "m12",
    title: "长安月",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20palace%20drama%20poster%20artwork%2C%20a%20lantern-lit%20ancient%20city%20at%20night%2C%20warm%20gold%20tones%2C%20no%20text&width=600&height=900&seq=poster-period-12&orientation=portrait",
    category: "剧集",
    tags: ["古装", "权谋"],
    desc: "一轮长安月下，看似平静的朝堂正在悄悄改写一座城的命运。",
    rating: "9.1",
    year: "2024",
  },
];

export const scenarios: ScenarioItem[] = [
  {
    id: "s1",
    image:
      "https://readdy.ai/api/search-image?query=A%20person%20watching%20a%20movie%20on%20a%20smartphone%20during%20an%20evening%20subway%20commute%2C%20warm%20screen%20glow%20on%20the%20face%2C%20shallow%20depth%20of%20field%2C%20cinematic%20mood%2C%20no%20text&width=800&height=600&seq=scenario-commute-01&orientation=landscape",
    title: "通勤路上缓存观看",
    desc: "上班路上信号忽强忽弱，提前把两集缓存好，全程不卡顿也不费流量。",
    icon: "ri-subway-line",
  },
  {
    id: "s2",
    image:
      "https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20with%20a%20large%20glowing%20television%20screen%20at%20night%2C%20warm%20ambient%20lighting%2C%20soft%20sofa%20and%20cushions%2C%20cinematic%20inviting%20mood%2C%20no%20text&width=800&height=600&seq=scenario-bigscreen-02&orientation=landscape",
    title: "客厅大屏高清追剧",
    desc: "回家把画面投到客厅大屏，选一档高清播放，画面细节和音效都更完整。",
    icon: "ri-tv-2-line",
  },
  {
    id: "s3",
    image:
      "https://readdy.ai/api/search-image?query=A%20family%20watching%20a%20movie%20together%20on%20a%20sofa%20in%20a%20warm%20living%20room%2C%20soft%20lamp%20light%2C%20cozy%20and%20harmonious%20atmosphere%2C%20no%20text&width=800&height=600&seq=scenario-family-03&orientation=landscape",
    title: "一家人周末共享",
    desc: "周末挑一部适合全家的片单，大人小孩都看得进去，气氛刚刚好。",
    icon: "ri-home-heart-line",
  },
  {
    id: "s4",
    image:
      "https://readdy.ai/api/search-image?query=A%20person%20relaxing%20alone%20on%20a%20bed%20late%20at%20night%20watching%20a%20movie%20on%20a%20laptop%2C%20dim%20warm%20room%20lighting%2C%20calm%20immersive%20mood%2C%20no%20text&width=800&height=600&seq=scenario-night-04&orientation=landscape",
    title: "深夜无广告沉浸",
    desc: "夜里想安静看完一集，无广告观看让剧情连贯，不用等、也不被打断。",
    icon: "ri-moon-clear-line",
  },
];

export const steps: StepItem[] = [
  {
    id: "g1",
    index: "01",
    title: "找到想看的作品",
    desc: "在片库中按类型浏览，或用关键词定位片名，先看看简介和评分再决定。",
  },
  {
    id: "g2",
    index: "02",
    title: "选择播放线路与画质",
    desc: "进入播放页后挑选合适的线路与清晰度，网络好就选高清，弱网自动降档更流畅。",
  },
  {
    id: "g3",
    index: "03",
    title: "在线观看或加入缓存",
    desc: "想马上看就点播放，想留到后面看就加入缓存，进度会自动记录在本地。",
  },
  {
    id: "g4",
    index: "04",
    title: "下载后离线观看",
    desc: "出行前把剧集下载到设备，路上没有网络也能接着上一集继续看。",
  },
];

export const qualityTiers: QualityItem[] = [
  {
    id: "q1",
    label: "流畅",
    resolution: "480P",
    scene: "移动网络、流量紧张时",
    data: "约 0.3GB / 小时",
  },
  {
    id: "q2",
    label: "高清",
    resolution: "720P",
    scene: "手机观剧、地铁通勤",
    data: "约 0.7GB / 小时",
  },
  {
    id: "q3",
    label: "全高清",
    resolution: "1080P",
    scene: "笔记本、客厅大屏",
    data: "约 1.5GB / 小时",
  },
  {
    id: "q4",
    label: "超高清",
    resolution: "4K",
    scene: "大屏电视、宽带充足",
    data: "约 3GB / 小时",
  },
];

export const reviews: ReviewItem[] = [
  {
    id: "r1",
    name: "林一舟",
    role: "通勤党",
    initials: "林",
    content: "每天坐地铁来回两小时，前一晚缓存好两集，路上基本不用等，进度也不会丢。",
  },
  {
    id: "r2",
    name: "苏晚",
    role: "追剧爱好者",
    initials: "苏",
    content: "同一部剧能选不同线路，偶尔某个线路慢，换一个就顺畅了，这点挺省心。",
  },
  {
    id: "r3",
    name: "陈默",
    role: "影迷",
    initials: "陈",
    content: "高清档位在客厅电视上细节不错，夜景和暗部也能看清，不会糊成一片。",
  },
  {
    id: "r4",
    name: "何子瑜",
    role: "学生",
    initials: "何",
    content: "免费观看的片库更新挺快，想看的纪录片在首页就能找到，不用到处搜。",
  },
  {
    id: "r5",
    name: "周然",
    role: "上班族",
    initials: "周",
    content: "深夜看剧最怕中途弹窗，无广告观看体验好很多，一集能一口气看完。",
  },
];

export const faqs: FaqItem[] = [
  {
    id: "f1",
    q: "茶杯狐影视可以直接在线观看吗？",
    a: "可以。本站以在线观看为入口，打开页面即可浏览片库并进入播放，不需要额外安装客户端。建议使用较新的浏览器，并保证网络稳定，以获得更顺畅的播放体验。",
  },
  {
    id: "f2",
    q: "免费观看和付费有什么区别？",
    a: "基础片库提供免费观看入口，可以直接浏览和播放常见热播内容。部分更新的片源或更高画质档位可能会有所区分，具体以页面当时展示的选项为准。",
  },
  {
    id: "f3",
    q: "高清播放需要多少网速？",
    a: "一般建议至少 4Mbps 以上带宽观看 720P，8Mbps 以上观看 1080P，4K 则建议 20Mbps 以上。网络不足时，播放器会自动降到较低档位，优先保证画面连贯不卡顿。",
  },
  {
    id: "f4",
    q: "下载和缓存有什么区别？",
    a: "缓存更偏向边看边存，进度实时保存，适合临时断网后继续；下载是主动把整集保存到本地，适合出行前提前准备，之后无网络也能完整观看。两者都会占用设备存储空间。",
  },
  {
    id: "f5",
    q: "缓存的进度会丢失吗？",
    a: "正常情况下缓存进度会保存在本地设备中，切换应用或短暂断网后重新打开通常可以从上次的位置继续。若清理了浏览器或应用的数据，缓存记录可能会一并被清除。",
  },
  {
    id: "f6",
    q: "无广告观看是所有内容都适用吗？",
    a: "无广告观看主要针对播放过程中的贴片与干扰性弹窗，尽量让剧情连贯。不同片源由不同线路提供，实际体验可能略有差异，请以播放页当时的情况为准。",
  },
  {
    id: "f7",
    q: "手机上观看需要注意什么？",
    a: "移动端建议在 Wi-Fi 环境下缓存或下载，避免消耗过多流量；屏幕较小的时候选 720P 已经足够清晰。长时间观看记得适当休息，保护眼睛。",
  },
  {
    id: "f8",
    q: "可以投屏到电视上观看吗？",
    a: "只要设备支持，一般可以通过系统自带的投屏或镜像功能把画面送到电视。大屏下建议选择 1080P 及以上档位，画面细节会更完整。",
  },
];

export const stats = [
  { id: "st1", value: "6", label: "大核心能力", icon: "ri-stack-line" },
  { id: "st2", value: "4 档", label: "清晰度可选", icon: "ri-aspect-ratio-line" },
  { id: "st3", value: "0", label: "播放中干扰", icon: "ri-shield-check-line" },
  { id: "st4", value: "24h", label: "随时想看就看", icon: "ri-time-line" },
];